/**
 * Name and initials for a user record, which the auth service may return either
 * as `firstName`/`lastName` parts or as a single `name`.
 *
 * Plain module rather than living beside `UserAvatar`, so that file exports only
 * a component and keeps fast refresh working.
 */
export function getUserInitials(user) {
  const fromParts = `${user?.firstName?.[0] ?? ""}${user?.lastName?.[0] ?? ""}`.trim();
  if (fromParts) return fromParts.toUpperCase();

  const name = user?.name;
  if (!name) return "?";

  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");
}

export function getUserDisplayName(user) {
  const fullName = `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim();
  return fullName || user?.name || "";
}
